import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { Button } from "reactstrap";
import Bar from "../../../components/common/ProgressBar";

const UploadedFile = ({ selectedFiles, showBar, handleProgressBar, setIsFileSizeLarge, uploadFileStatus,uploadFileStatusMessage }) => {
  const [realTime, setRealTime] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const filesize = useMemo(()=>(selectedFiles[0]?.size))
  let [counter,setCounter] = useState(0);
  
  const currentTime = useMemo(()=>(Date.now()))
  return (
    <>
      <ul className="uploaded-file list-unstyled" style={{ zIndex: 1 }}>
        <li>
          {selectedFiles.length
            ? selectedFiles.map((_file, index) => (
              <>
                <div
                  className="head-blc d-flex align-items-center"
                  key={`file_${index}`}
                >
                  <label>{_file.name}</label>
                  <div className="col-rt ms-auto">
                    {/*<Button
                      color="link"
                      className="pause-btn"
                      onClick={() => {
                        setRealTime(!realTime)
                        setIsPaused(!isPaused)
                      }}
                    >
                      <span className="d-inline-flex align-items-center justify-content-center rounded-circle">
                        {!realTime ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="11"
                            viewBox="0 0 9 11"
                          >
                            <g
                              id="Group_41"
                              data-name="Group 41"
                              transform="translate(-1027.5 -735.5)"
                            >
                              <line
                                id="Line_4"
                                data-name="Line 4"
                                y2="9"
                                transform="translate(1028.5 736.5)"
                                fill="none"
                                stroke="#464952"
                                strokeLinecap="round"
                                strokeWidth="2"
                              />
                              <line
                                id="Line_5"
                                data-name="Line 5"
                                y2="9"
                                transform="translate(1035.5 736.5)"
                                fill="none"
                                stroke="#464952"
                                strokeLinecap="round"
                                strokeWidth="2"
                              />
                            </g>
                          </svg>
                        ) : (
                          <FontAwesomeIcon icon={faPlay} />
                        )}
                      </span>
                        </Button>*/}
                    {counter == 1 && <Button
                      color="link"
                      className="cancel-btn"
                      onClick={handleProgressBar}
                    >
                      <span className="d-inline-flex align-items-center justify-content-center rounded-circle">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="11.828"
                          height="11.828"
                          viewBox="0 0 11.828 11.828"
                        >
                          <g
                            id="Group_42"
                            data-name="Group 42"
                            transform="translate(-1068.086 -735.086)"
                          >
                            <line
                              id="Line_6"
                              data-name="Line 6"
                              x2="9"
                              y2="9"
                              transform="translate(1069.5 736.5)"
                              fill="none"
                              stroke="#bc3e3f"
                              strokeLinecap="round"
                              strokeWidth="2"
                            />
                            <line
                              id="Line_7"
                              data-name="Line 7"
                              x1="9"
                              y2="9"
                              transform="translate(1069.5 736.5)"
                              fill="none"
                              stroke="#bc3e3f"
                              strokeLinecap="round"
                              strokeWidth="2"
                            />
                          </g>
                        </svg>
                      </span>
                    </Button>
                    }
                  </div>
                    
                </div>
                <div key={`${_file.path}_${index}`} className="inner-blc">
                  {showBar && <Bar action={realTime} selectedFiles={selectedFiles} isPaused={isPaused} currentTime={currentTime} filesize={filesize} setIsFileSizeLarge={setIsFileSizeLarge} uploadFileStatus={uploadFileStatus} uploadFileStatusMessage={uploadFileStatusMessage} _counter={(counter)=> {setCounter(counter); console.log('counter',counter)}}/>}
                </div>
              </>
            ))
            : null}
        </li>
      </ul>
    </>
  );
};

export default UploadedFile;
